export enum BILLING_INFORMATION_TYPE {
  BILLED_MONTHS = 'billedMonths',
  BILLING_MONTHS = 'billingMonths',
  BILLING_ACTUAL_MONTH = 'billingActualMonth',
  BILLING_PREVIEW_MONTHS = 'billingPreviewMonths',
}
